import React from 'react';
import Swiper from 'swiper/core';
import { Link } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
// model && interfaces
import Data from '../../model/Data';
import VacancyInterface from '../../model/Vacancy';
import CityInterface from '../../model/City';
import AreaInterface from '../../model/Area';
// common components
import VacancyPlate from '../../common/components/VacancyPlate/VacancyPlate';
import SwiperCarousel from '../../common/components/Swiper/SwiperCarousel';
import Grid from '../../common/components/Grid/Grid';
import ApplyForm from '../../common/components/ApplyForm/ApplyForm';
// Local components
import Header from './components/Header/Header';
import DesktopFormBlock from './components/DesktopFormBlock/DesktopFormBlock';
import MobileFormBlock from './components/MobileFormBlock/MobileFormBlock';
// helpers
import ResizeHelper from '../../common/helpers/resize';
// Images
import RedArrows from './components/Description/img/red_arrows.svg';
// Analytics
import gtag from '../../common/components/analytics/gtag.js';
import useYandexRotor from "../../common/helpers/useYandexRotor";

interface MatchParams {
  id: string;
  city: string;
  area: string;
}

type Props = RouteComponentProps<MatchParams>;

class SpecialVacancy extends React.Component<Props> {

  private vacancies: Array<VacancyInterface>;

  private city: CityInterface;

  private area: AreaInterface;

  constructor(props: Props) {
    super(props);
    const uriParams: MatchParams = this.props.match.params;
    const { city, area } = uriParams;
    this.city = Data.Instance.cityByAlias(city);
    this.area = Data.Instance.areaByAlias(area);
    this.vacancies = Data.Instance.vacancies({city: this.city.id, area: this.area.id});
    ResizeHelper.Instance.addCallback(this.refresh.bind(this));
  }

  refresh(): void {
    this.setState((prevState) => ({...prevState}))
  }

  private vacancyPlates() {
    const plates = this.vacancies.map((v) => {
      return (
        <VacancyPlate
          key={v.id}
          city={this.city}
          vacancy={v}
        />
      );
    });
    plates.push(
      <Link
        key={`/${this.city.uri_alias}/${this.area.uri_alias}/special-vacancy`}
        to={`/${this.city.uri_alias}/${this.area.uri_alias}/special-vacancy`}
        className={`vacancy vacancy-plate special-vacancy-plate item selected`}
      >
        <div className="name">Нет вакансии для тебя?</div>
        <div className="description">
          Расскажи, кем ты себя видишь в Учи.ру
        </div>
      </Link>
    );
    return plates;
  }


  private leftbarText(isDesktop = true) {
    if (isDesktop) {
      return (
        <>
          <span>Расскажи, кем ты</span><br/>
          <span>себя видишь</span><br/>
          <span>в Учи.ру</span>
        </>
      );
    } else {
      return (
        <>
          <span>Расскажи, кем ты себя</span><br/>
          <span>видишь в Учи.ру</span>
        </>
      );
    }
  }


  private onSwiper(swiper: Swiper) {
    const slideTo = (i: number) => {
      swiper.slideTo(i);
    }

    swiper.slides.forEach((slide, i) => {
      slide.addEventListener("click", () => { slideTo(i)} );
    })
  }

  render(): JSX.Element {
    const windowWidth = window.innerWidth;
    const initialSlideId = this.vacancies.length;
    let leftbarGridClass = Grid.itemClass(4);
    let formGridClass = Grid.itemClass(4);

    if (windowWidth > 767 && windowWidth < 1024) {
      leftbarGridClass = Grid.itemClass(8);
      formGridClass = Grid.itemClass(8);
    } else if (windowWidth >= 1024 && windowWidth < 1280) {
      leftbarGridClass = Grid.itemClass(2);
      formGridClass = Grid.itemClass(6);
    } else if (windowWidth >= 1280) {
      leftbarGridClass = Grid.itemClass(4);
      formGridClass = Grid.itemClass(8);
    }

    useYandexRotor(Data.Instance.isDataLoaded);

    // GoogleAnalytics event
    gtag('event', 'show', {
      'event_category': 'vacancy_form',
      'event_label': 'form_vacancy_empty'
    });

    return (
      <div className="vacancy-detailed">
        <Header area={this.area} city={this.city}></Header>
        <div className="vacancies">
          <SwiperCarousel onSwiper={ this.onSwiper.bind(this) } initialSlide={ initialSlideId > -1 ? initialSlideId : 0}>
            { this.vacancyPlates() }
          </SwiperCarousel>
        </div>
        <div className="details-dummy vacancy-details">
          <div className="after">
            <img src={RedArrows} alt=""/>
          </div>
        </div>
        <MobileFormBlock className="hidden mobile-visible tablet-visible" text={this.leftbarText(false)}/>
        <DesktopFormBlock className="mobile-hidden tablet-hidden" text={this.leftbarText()}/>
      </div>
    );
  }
}

export default SpecialVacancy;
